import {FC} from 'react';

import {Check} from '@mui/icons-material';
import {Radio, RadioProps} from '@mui/material';
import {styled} from '@mui/material/styles';

import {greenColors, orangeColors} from '../../../layouts/theme/designSystem';

const UiRadio: FC<RadioProps> = styled((props) => (
  <Radio
    color='default'
    {...props}
    icon={<span className='radio-icon' />}
    checkedIcon={
      <span className='radio-icon-checked'>
        <Check />
      </span>
    }
  />
))(({theme}) => ({
  '& .radio-icon': {
    borderRadius: '50%',
    width: 16,
    height: 16,
    backgroundColor: greenColors[100],
  },
  '& .radio-icon-checked': {
    backgroundColor: orangeColors[100],
    borderRadius: '50%',
    width: 16,
    height: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      fontSize: 16,
      color: theme.palette.background.paper,
    },
  },
}));

export default UiRadio;
